import script from "./Siding02DetailsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding02DetailsSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__